import React from 'react';
import { BaasicModalTemplate } from 'themes/components';
import { observer } from 'mobx-react';

function BaasicModal(props) {
	return <BaasicModalTemplate {...props} />;
}

export default observer(BaasicModal);



// WEBPACK FOOTER //
// ./src/core/components/dialog/BaasicModal.jsx